module.exports = __webpack_public_path__ + "static/media/default-location-image.cf5e808e.jpg";